var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"piechart-wrapper"},[_c('pie-chart',{staticStyle:{"width":"55%"},attrs:{"data":_vm.data,"labels":_vm.labels,"percentage":_vm.percentage,"borderWidth":_vm.borderWidth,"colors":this.colors,"unitTranslationKey":_vm.unitTranslationKey}}),_c('legend-pie',{attrs:{"labels":_vm.labels,"colors":this.colors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }